var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7 6.4c-1.3-.6-2.6-1-4-1.3-.2.3-.4.7-.5 1.1-1.5-.2-3-.2-4.4 0-.2-.3-.4-.7-.5-1.1-1.4.2-2.8.7-4 1.3C2.7 10.2 2 14 2.4 17.7c1.7 1.3 3.3 2 4.9 2.5.4-.5.7-1.1 1.1-1.7-.6-.2-1.1-.5-1.7-.8.1-.1.3-.2.4-.3 3.2 1.5 6.7 1.5 9.8 0 .1.1.3.2.4.3-.5.3-1.1.6-1.7.8.3.6.7 1.2 1.1 1.7 1.6-.5 3.2-1.3 4.9-2.5.4-4.3-.7-8-2.9-11.3zm-9.9 9c-1 0-1.7-.9-1.7-2s.8-2 1.7-2c1 0 1.8.9 1.7 2 0 1.1-.8 2-1.7 2zm6.4 0c-1 0-1.7-.9-1.7-2s.8-2 1.7-2c1 0 1.8.9 1.7 2 .1 1.1-.7 2-1.7 2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/Discord.015542df.svg";
export { ForwardRef as ReactComponent };